import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Center } from '../interfaces/center';

@Injectable({
  providedIn: 'root'
})
export class CenterService {
  private myAppUrl: string;
  private myApiUrl: string;

  constructor(private http: HttpClient) {
    this.myAppUrl = environment.endpoint;
    this.myApiUrl = 'api/centers/'
  }
  getListCenters(): Observable<Center[]> {

      return this.http.get<Center[]>(`${this.myAppUrl}${this.myApiUrl}`);
     }
   
     deleteCenter(id: number): Observable<void> {
       return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     saveCenter(center: Center): Observable<void> {
       return this.http.post<void>(`${this.myAppUrl}${this.myApiUrl}`,center)
     }
   
     getCenter(id: number): Observable<Center> {
       return this.http.get<Center>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     updateCenter(id: number, center: Center): Observable<void> {
       return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}`, center);
     }
   }